import React from "react";

const Bubble = ({ count }) => {
  return (
    <span className="absolute top-0 right-0 mt-1 mr-2 bg-red-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-md">
      {count}
    </span>
  );
};

export default Bubble;